/**
 * Search Page Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive search page with advanced features:
 * - Qdrant vector database integration for semantic search
 * - Auth0 authentication gating for member-only access
 * - Live search capabilities with real-time results
 * - Vector similarity search for intelligent content discovery
 * - Member-only content filtering and access control
 * - Clean and responsive search interface
 * - Integration with external search services
 * 
 * Features:
 * - Authentication-based access control
 * - QdrantLiveSearch component integration
 * - Real-time search result updates
 * - Vector database semantic search
 * - Member authentication validation
 * - Responsive design for various screen sizes
 * - Clean and minimal search interface
 * 
 * @returns {JSX.Element|null} Search page component with semantic search capabilities, null if not authenticated
 */
import React, { useContext } from 'react';
import '../css/Colors.css';
import QdrantLiveSearch from '../components/Search/QdrantLiveSearch';
import { AuthContext } from '../components/Auth/AuthContext';

/**
 * Search component for semantic search functionality
 * with Auth0 authentication and Qdrant integration
 */
function Search() {
    const { user: [user] } = useContext(AuthContext);
    const isAuthenticated = !!user;

    if (!isAuthenticated) {
        return null;
    }

    return (
        <section className="wrapper">
            <div className="container mt-6 pb-6">
                <QdrantLiveSearch />
            </div>
        </section>
    );
}

export default Search;